<template>
  <Bar :data="barChartData" :options="barChartOptions" />
</template>

<script>
import { Bar } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, TimeScale } from "chart.js";
import "chartjs-adapter-moment";
import { useTheme } from "vuetify";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, TimeScale);

export default {
  name: "StackedBarChart",
  components: { Bar },
  setup() {
    const theme = useTheme();
    return { theme };
  },
  props: {
    chartData: Array,
    chartLabels: Array,
    showLegend: Boolean,
  },
  computed: {
    barChartData() {
      const c = this.theme.current.value.colors;
      return {
        datasets: this.chartData.map((dataset, i) => ({
          ...dataset,
          backgroundColor: c[`chart-${(i % 5) + 1}`],
        })),
        labels: this.chartLabels,
      };
    },
    barChartOptions() {
      return {
        scales: {
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
          x: {
            stacked: true,
            categoryPercentage: 1.0,
            type: "time",
            distribution: "series",
            time: { parser: "YYYY-MM-DDTHH:mm", tooltipFormat: "ll" },
            ticks: {
              source: "data",
              maxRotation: 90,
              minRotation: 90,
              autoSkip: false,
              stepSize: 1,
            },
          },
        },
        plugins: {
          legend: {
            display: this.showLegend,
          },
        },
      };
    },
  },
};
</script>
